
const AUTH_TOKEN = "AUTH_TOKEN"
const REFRESH_TOKEN = "RefreshToken"
const USER_DATA = "USER_DATA"
export { AUTH_TOKEN, REFRESH_TOKEN, USER_DATA }
